import { useDateFns } from '~/Hooks';
import { EventGroupDefaultValue } from '~/Models/DTO/EventGroup.model';
import { DifferenceFormat } from '~/Models/DTO/Time.model';

export const useTimeFormatter = () => {
  const { formatDate, parse } = useDateFns();

  const minutesAsNumbersToBackendFormat = (time: number) => {
    const MINUTES_IN_ONE_HOUR = 60;

    const minutes = time % MINUTES_IN_ONE_HOUR;
    const hours = (time - minutes) / MINUTES_IN_ONE_HOUR;
    const hoursAndMinutes = `${hours.toString().padStart(2, '0')}.${minutes
      .toString()
      .padStart(2, '0')}`;

    return formatDate(parse(hoursAndMinutes, 'HH.mm', new Date()).toUTCString(), '-HH:mm:ss');
  };

  const hoursAsNumbersToBackendFormat = (time: number) =>
    time > 23
      ? formatDate(
          parse(
            `${Math.floor(time / 24)}.${time % 24 < 10 ? '0' : ''}${time % 24}`,
            'd.HH',
            new Date(),
          ).toUTCString(),
          '-d.HH:mm:ss',
        )
      : formatDate(parse(`${time}`, 'HH', new Date()).toUTCString(), '-HH:mm:ss');

  const formatTimeAsNumberToBackendPattern = (time: number, type = DifferenceFormat.HOURS) => {
    try {
      return type === DifferenceFormat.HOURS
        ? hoursAsNumbersToBackendFormat(time)
        : minutesAsNumbersToBackendFormat(time);
    } catch {
      return EventGroupDefaultValue.publicCancellationWindowEnd;
    }
  };

  return {
    formatTimeAsNumberToBackendPattern,
  };
};
